import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild } from '@angular/core';
import * as dateFns from 'date-fns';
import { Calendar } from '../../utils/Calendar';
import { CalendarEvent } from '../../utils/CalendarEvent';
import { NgbDatepickerConfig, NgbDateStruct, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';

import { getEventsInPeriod, isEventIsPeriod } from '../../utils/common';

import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
export class YearViewComponent implements OnInit, OnChanges {
/**
 * The current view date
 */
viewDate: Date;
/**
 * An array of calendars to display on view.
 */
calendars: Calendar[] = [];
/**
 * An observable that when emitted on will re-render the current view
 */
refresh: Subject<any>;
/**
 * @hidden
 */
refreshSubscription: Subscription;

   ngbDatepicker: NgbDatepicker;


  displayMonths = 12;
  navigation = 'none';
  showWeekNumbers = false;
/**
 * Called when the event title is clicked
 */
dayClicked: EventEmitter<{ day: Date, events: CalendarEvent[] }> = new EventEmitter<{
    day: Date;
    events: CalendarEvent[];
  }>();

  startDate;
/**
 * @param {?} config
 */
constructor(private config: NgbDatepickerConfig) {
    this.startDate = { year: new Date().getFullYear(), month: 1 };
  }
/**
 * @return {?}
 */
ngOnInit() {
    if (this.refresh) {
      this.refreshSubscription = this.refresh.subscribe(() => {
        const /** @type {?} */ toDay = { year: this.viewDate.getFullYear(), month: dateFns.getMonth(this.viewDate) + 1, day: this.viewDate.getDate() };
        this.startDate = { year: this.viewDate.getFullYear(), month: 1 };
        this.ngbDatepicker.navigateTo(toDay);
      });
    }
  }
/**
 * @hidden
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: any): void {
    if (changes.viewDate) {
      const /** @type {?} */ toDay = { year: this.viewDate.getFullYear(), month: dateFns.getMonth(this.viewDate) + 1, day: this.viewDate.getDate() };
      this.startDate = { year: this.viewDate.getFullYear(), month: 1 };
      this.ngbDatepicker.navigateTo(toDay);
    }
  }
/**
 * @param {?} date
 * @return {?}
 */
daySelected(date) {
    const /** @type {?} */ events = [];
    const /** @type {?} */ day = new Date(date.year, date.month - 1, date.day);
    this.calendars.map(calendar => {
      calendar.events.map(event => {
        if (isEventIsPeriod({ event, periodStart: dateFns.startOfDay(day), periodEnd: dateFns.endOfDay(day) })) {
          events.push(event);
        }
      });
    });
    this.dayClicked.emit({ day: day, events: events });
  }
/**
 * @param {?} date
 * @return {?}
 */
isToday(date) {
    const /** @type {?} */ day = new Date(date.year, date.month - 1, date.day);
    const /** @type {?} */ currentDay = new Date();
    if (day.getDate() === currentDay.getDate() &&
      day.getFullYear() === currentDay.getFullYear() &&
      day.getMonth() === currentDay.getMonth()) {
      return true;
    } else {
      return false;
    }
  }
/**
 * @param {?} date
 * @return {?}
 */
isReserved(date) {
    const /** @type {?} */ day = new Date(date.year, date.month - 1, date.day);
    let /** @type {?} */ isReserved = false;
    this.calendars.map(calendar => {
      calendar.events.map(event => {
        if (isEventIsPeriod({ event, periodStart: dateFns.startOfDay(day), periodEnd: dateFns.endOfDay(day) })) {
          isReserved = true;
        }
      });
    });
    return isReserved;
  }
/**
 * @param {?} date
 * @return {?}
 */
getColor(date) {
    const /** @type {?} */ day = new Date(date.year, date.month - 1, date.day);
    let /** @type {?} */ color = 'transparent';
    this.calendars.map(calendar => {
      calendar.events.map(event => {
        if (isEventIsPeriod({ event, periodStart: dateFns.startOfDay(day), periodEnd: dateFns.endOfDay(day) })) {
          color = calendar.color;
        }
      });
    });
    return color;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'calendar-year-view',
  template: `
    <ngb-datepicker [startDate]="startDate" (select)="daySelected($event)" [dayTemplate]="customDay" [displayMonths]="displayMonths" [navigation]="navigation"
      [showWeekNumbers]="showWeekNumbers">
    </ngb-datepicker>
    <ng-template #customDay let-date="date" let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
      <span class="custom-day" [class.focused]="focused" [class.bg-primary]="isToday(date)" [class.bg-grey]="isReserved(date)"
        [class.hidden]="date.month !== currentMonth" [style.backgroundColor]="getColor(date)" [class.text-muted]="disabled">
        {{ date.day }}
      </span>
    </ng-template>
  `,
  styles: [`
    .custom-day {
      text-align: center;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
      -webkit-box-pack: center;
          -ms-flex-pack: center;
              justify-content: center;
      width: 2rem;
      height: 2rem;
      font-size: 12px; }

    .custom-day.bg-primary, .custom-day.bg-primary:hover, .custom-day:hover {
      background-color: #40dc7e !important;
      color: white !important;
      border-radius: 50%; }

    .custom-day.bg-grey {
      background-color: #f2f2f2;
      color: white;
      border-radius: 0 !important;
      border-top: 2px solid white; }

    .custom-day.bg-grey:hover {
      border-radius: 0 !important;
      background-color: #40dc7e !important;
      border-bottom: 2px solid #40dc7e;
      color: white; }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgbDatepickerConfig, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'viewDate': [{ type: Input },],
'calendars': [{ type: Input },],
'refresh': [{ type: Input },],
'ngbDatepicker': [{ type: ViewChild, args: [NgbDatepicker, ] },],
'dayClicked': [{ type: Output },],
};
}

function YearViewComponent_tsickle_Closure_declarations() {
/** @type {?} */
YearViewComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YearViewComponent.ctorParameters;
/** @type {?} */
YearViewComponent.propDecorators;
/**
 * The current view date
 * @type {?}
 */
YearViewComponent.prototype.viewDate;
/**
 * An array of calendars to display on view.
 * @type {?}
 */
YearViewComponent.prototype.calendars;
/**
 * An observable that when emitted on will re-render the current view
 * @type {?}
 */
YearViewComponent.prototype.refresh;
/**
 * @hidden
 * @type {?}
 */
YearViewComponent.prototype.refreshSubscription;
/** @type {?} */
YearViewComponent.prototype.ngbDatepicker;
/** @type {?} */
YearViewComponent.prototype.displayMonths;
/** @type {?} */
YearViewComponent.prototype.navigation;
/** @type {?} */
YearViewComponent.prototype.showWeekNumbers;
/**
 * Called when the event title is clicked
 * @type {?}
 */
YearViewComponent.prototype.dayClicked;
/** @type {?} */
YearViewComponent.prototype.startDate;
/** @type {?} */
YearViewComponent.prototype.config;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
